import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { Row } from '@/design-system/components/layout';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { UpdateCardKycStackParamList } from './type';
import { PageHeaderModalNative } from '../../../account-management/screens/page/PageHeaderModalNative';

export interface CardKycInfoPlacedProps {
  onClose: () => void;
  data: any;
  returnData?: any;
  refresh?: () => void;
}

export const CardKycInfoPlacedNativeScreen: React.FC<CardKycInfoPlacedProps> = (props) => {
  const { t } = useTranslation('card-account');
  const {
    topHeader,
    body,
    btnView,
    btn,
    textHeaderTitle,
    modal
  } = sxStyles;

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<UpdateCardKycStackParamList>>();

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account::credit-card-new-account.glossary.kyc-info')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="checkCircleBlue" height={108} width={108} />
          <H6 bold sx={textHeaderTitle}>
            {t('card-account::credit-card-new-account.update-kyc-info-page.title--update-success-placed')}
          </H6>
        </View>
        <View sx={body}>
          <View sx={btnView}>
            <UniButton
              sx={btn}
              labelSx={{ color: '$balck' }}
              label={t('card-account-management::general.button--close')}
              onPress={() => {
                navigation.getParent()?.goBack();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault'
  },
  body: {
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btnView: {
    flex: 1,
    display: 'grid',
    gap: '$3',
    mt: '$4'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  }
};